
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corsoadozionale/[slug]",
      function () {
        return require("private-next-pages/corsoadozionale/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corsoadozionale/[slug]"])
      });
    }
  